import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getAllPortfolios } from '@/app/api/manage-portfolios/manage-portfolios.api';
import { PaginationQueryParams } from '@/app/api';

export const managePortfoliosKeys = createQueryKeys('manage_portfolios', {
	portfolios: ({ page, size }: PaginationQueryParams) => ({
		queryKey: ['portfolios', page, size],
		queryFn: () => getAllPortfolios({ page, size }),
	}),
});
